import styled from '@emotion/styled'

export const LoanStepInputStyles = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  flex-direction: column;
  text-align: center;

  .text-color-primary {
    color: rgb(var(--colors-pink));
  }

  .label-value,
  .label {
    font-size: 1.125rem;
  }
  .label-value {
    font-weight: 600;
    margin: 0.5rem 0;
  }

  .input-legend {
    display: flex;
    width: 100%;
    justify-content: space-between;
    font-size: 0.875rem;
  }
`
export const LoanInputStyles = styled.input`
  -webkit-appearance: none;

  border-radius: 0.625rem;
  background: #e4e2e2db;
  background-image: linear-gradient(rgba(var(--theme-primary)), rgba(var(--theme-primary)));
  background-size: 0% 100%;
  background-repeat: no-repeat;
  margin: 0.625rem 0;
  height: 0.375rem;

  ::-webkit-slider-runnable-track {
    -webkit-appearance: none;
    box-shadow: none;
    border: none;
    background: transparent;
    height: 0.375rem;
  }

  ::-moz-range-track {
    -webkit-appearance: none;
    box-shadow: none;
    border: none;
    background: transparent;
    height: 0.375rem;
  }

  ::-ms-track {
    -webkit-appearance: none;
    box-shadow: none;
    border: none;
    background: transparent;
    height: 0.375rem;
  }

  ::-webkit-slider-thumb {
    box-shadow: none;
    border: none;
    height: 1.125rem;
    width: 1.125rem;
    border-radius: var(--theme-border-radius);
    background: rgba(var(--theme-primary));
    cursor: ew-resize;
    -webkit-appearance: none;
    margin-top: -0.375rem;
  }

  ::-moz-range-thumb {
    box-shadow: none;
    border: none;
    height: 1.125rem;
    width: 1.125rem;
    border-radius: var(--theme-border-radius);
    background: rgba(var(--theme-primary));
    cursor: ew-resize;
    -webkit-appearance: none;
    margin-top: -0.375rem;
  }

  :focus {
    outline: none;
  }
`
